import ACurrentPhone from './index.vue';

ACurrentPhone.install = app => {
  app.component(ACurrentPhone.name, ACurrentPhone);
};

export default ACurrentPhone;
